import { render, staticRenderFns } from "./HomeWelcome.vue?vue&type=template&id=f8b08d3a&scoped=true"
import script from "./HomeWelcome.vue?vue&type=script&lang=js"
export * from "./HomeWelcome.vue?vue&type=script&lang=js"
import style0 from "./HomeWelcome.vue?vue&type=style&index=0&id=f8b08d3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b08d3a",
  null
  
)

export default component.exports